import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LocalhostKeys } from './shared/enum/localhost-keys';
import { PersonalizationService } from './shared/services/personalization.service';
import { LangService } from './shared/services/lang.service';
import { PermissionsService } from './shared/services/permissions.service';
import { UsersService } from './shared/services/users.service';
import { SessionService } from './shared/services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'adminux';
  titlepage: string = '';

  constructor(
    public personalizationService: PersonalizationService,
    private langService: LangService,
    private permissionsService: PermissionsService,
    private sessionService: SessionService
  ) {
  }

  ngOnInit (): void {
    // this.sessionService.startSessionMonitor();
    const themeColor = localStorage.getItem(LocalhostKeys.THEME_COLOR) ?? 'theme-default';
    this.personalizationService.setThemeColor(themeColor, 'theme-default');
    const sidebarFillColor = localStorage.getItem(LocalhostKeys.SIDEBAR_FILL_COLOR) ?? 'sidebar-filled';
    this.personalizationService.setSidebarFillColor(sidebarFillColor, 'sidebar-filled');
    const backgroundImage = localStorage.getItem(LocalhostKeys.BACKGROUND_IMAGE) ?? 'assets/img/bg-1.jpg';
    setTimeout(() => {
      this.personalizationService.setBackgroundImage(backgroundImage);
    }, 500);
    const sidebarStyle = localStorage.getItem(LocalhostKeys.SIDEBAR_STYLE) ?? 'sidebar-pushcontent';
    this.personalizationService.setSidebarStyle(sidebarStyle, 'sidebar-pushcontent');
    const theme = localStorage.getItem(LocalhostKeys.THEME) ?? 'sidebar-pushcontent';
    this.personalizationService.setTheme(theme, 'theme-default');
    const mode = localStorage.getItem(LocalhostKeys.MODE) ?? 'light-mode';
    setTimeout(() => {
      const defaultMode = mode === 'light-mode' ? 'dark-mode' : 'light-mode';
      this.personalizationService.setMode(mode, defaultMode);
    }, 500);

    let body = document.getElementsByTagName('body')[0];
    if (window.innerWidth < 992) {
      body.classList.add('menu-close');
    } else {
      body.classList.remove('menu-close');
    }
    this.langService.init();
  }

  @HostListener('window:resize', [])
  onWindowResize () {
    let body = document.getElementsByTagName('body')[0];
    if (window.innerWidth < 992) {
      body.classList.add('menu-close');
    } else {
      body.classList.remove('menu-close');
    }
  }
}
